import { app } from './conn.js';
import { getAuth } from "firebase/auth";

export const auth = getAuth(app);

